export default function UptimeMonitor() {
    return(
        <div>
            Uptime Monitor
        </div>
    )
};
